// Types
import type { TListingFilters, TStoredFilters } from '~/misc/listings/types';

/**
 * Extracts storable filter fields from listing filters.
 *
 * Boolean-like toggle fields (exclude_sold_since, contactable_only,
 * exclude_archived, exclude_actioned_properties) are always included so that `wrapForSave` can
 * correctly overwrite previously saved non-default values.
 *
 * @param filters - The full listing filters object
 */
export const extractStoredFilters = (filters: TListingFilters): TStoredFilters => {
  return {
    price_range: {
      from: filters.price_range.from ?? null,
      to: filters.price_range.to ?? null,
    },
    bed_range: {
      from: filters.bed_range.from ?? null,
      to: filters.bed_range.to ?? null,
    },
    category: filters.category,
    date: filters.date ?? null,
    vendor_since: filters.vendor_since,
    landlord_since: filters.landlord_since,
    applicant_since: filters.applicant_since,
    agents: filters.agents?.length ? [...filters.agents] : null,
    location: filters.location ?? null,
    exclude_sold_since: filters.exclude_sold_since,
    contactable_only: filters.contactable_only,
    exclude_archived: filters.exclude_archived,
    exclude_actioned_properties: filters.exclude_actioned_properties,
    exclude_crm_activity_since: filters.exclude_crm_activity_since,
    hidden: filters.hidden,
    // Array fields: always include so the merge payload correctly
    // overwrites any previously saved selection — an empty array
    // is a valid value meaning "nothing selected".
    marketing_consent: filters.marketing_consent,
    contact_type: filters.contact_type,
    entity_status: filters.entity_status,
  };
};
